import { connect } from 'react-redux'

import { startLoading, stopLoading } from './reducer'

const mapStateToProps = (state) => {
    return {
        loading: state?.components?.mainLoader?.loading,
    }
}

const mapDispatchToProps = { startLoading, stopLoading }

const hocLoaderPopup = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocLoaderPopup
